import { companyApiClient } from "@/api/companyApiClient";
import { DCEvent, navigate, updateStore } from "@/events/eventsDomain";
import { adminBase, portfolioUrl } from "@/utils/navigation";

export type CompanyIds = Record<string, string>;

const companyIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const companyPathPattern = /^\/company\/([^/?#]+)(.*)$/s;

export const isCompanyId = (value: string): boolean => companyIdPattern.test(value);

const replaceCompanySegment = (
  path: string,
  replacementFor: (segment: string) => string | undefined,
): string => {
  const match = companyPathPattern.exec(path);
  const replacement = match ? replacementFor(match[1]) : undefined;
  return match && replacement ? adminBase(replacement) + match[2] : path;
};

export const toAppPath = (path: string, companyIds: CompanyIds = {}): string =>
  replaceCompanySegment(path, (segment) => companyIds[segment]);

export const toBrowserPath = (path: string, companyIds: CompanyIds = {}): string =>
  replaceCompanySegment(path, (segment) =>
    Object.keys(companyIds).find((companyId) => companyIds[companyId] === segment),
  );

export const resolveCompanyId = (
  companyId: string,
  location: { pathname: string; search: string },
): DCEvent[] => [
  companyApiClient.fetchCompanyInfo(companyId, {
    onSuccess: ({ data }) => [
      updateStore({
        companyIds: (current) => ({ ...current, [companyId]: data.company.organizationnumber }),
      }),
      navigate(location.pathname + location.search, { replace: true }),
    ],
    onFailure: () => [navigate(portfolioUrl, { replace: true })],
  }),
];
